import { useState, useEffect } from 'react';
import { themeI18n } from '../utils/i18n_helper';

import { StoresDrawer } from './StoresDrawer.js';

import Icons from './Icons.js';
import { multilingual_url } from '../utils/multilingual-url.js';

const storeLocationsData = JSON.parse(document.querySelector('[data-store-locations-data]').innerHTML).locations;
const myStore = JSON.parse(localStorage.getItem('theme:my_store')) ?? storeLocationsData[0].id;

export const InventoryStatus = ({ inventoryData }) => {
  const [locationInventories, setLocationInventories] = useState(inventoryData.selected_variant_location_inventories); // location inventories for current variant
  const [myStoreLocation, setMyStoreLocation] = useState(myStore); // Id of "my store" location metaobject
  const [myStoreLocationSinceDrawerOpened, setMyStoreLocationSinceDrawerOpened] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const myStoreLocationData = myStoreLocation ? storeLocationsData.find(location => location.id == myStoreLocation) : storeLocationsData[0]; // Location metaobject for "my store" or first location if not set
  const myStoreInventoryData = locationInventories?.find(location => location.location_id == myStoreLocationData.shopify_id); // Inventory data for "my store"

  const pickupStatus = myStoreInventoryData.available && myStoreInventoryData.pick_up_enabled ? 'in-stock' : 'sold-out'; // Pickup status for "my store"
  const inStoreStatus = myStoreInventoryData.available ? 'in-stock' : 'sold-out'; // In-store status for "my store"

  const handleMyStoreUpdate = (event) => {
    setMyStoreLocation(event.detail);
  }

  const handleVariantChange = async (event) => {
    const variantId = event.detail;
    setIsLoading(true);

    const response = await fetch(multilingual_url(`/products/${inventoryData.product_handle}?variant=${variantId}&view=location_inventories`));

    if (response.ok) {
      const data = await response.json();

      setLocationInventories(data.selected_variant_location_inventories);
      setIsLoading(false);
    }
  }

  const handleOpenDrawer = () => {
    window.dispatchEvent(new CustomEvent('open_locations_drawer_inventory'));
    setMyStoreLocationSinceDrawerOpened(myStoreLocation);
  }

  useEffect(() => {
    window.addEventListener('myStoreChanged', (event) => handleMyStoreUpdate(event));
    window.addEventListener('variantChanged', (event) => handleVariantChange(event));

    return () => {
      window.removeEventListener('myStoreChanged', (event) => handleMyStoreUpdate(event));
      window.removeEventListener('variantChanged', (event) => handleVariantChange(event));
    }
  },[]);


  return (
    <>
      {myStoreInventoryData && (
        <>
          {/* Pickup status */}
          <div className={`inventory-status__status ${pickupStatus} ${isLoading ? 'loading' : ''}`}>
            <div className='inventory-status__status-title'>
              {themeI18n('products.inventory.in_store_pickup')}
            </div>

            <span className="inventory-status__content">
              <span className="inventory-status__text inventory-status__text--in-stock">
                <Icons icon='success' size='small' />
                <span>
                  {themeI18n('products.inventory.pickup_available_in_at', {time: myStoreInventoryData.pickup_time})}
                  <button
                    className='inventory-status__text-link'
                    onClick={()=> handleOpenDrawer()}
                  >
                    {myStoreLocationData.name}
                  </button>
                </span>
              </span>

              <span className="inventory-status__text inventory-status__text--sold-out">
                <Icons icon='error' size='small' />
                <span>
                  {themeI18n('products.inventory.pickup_unavailable_at')}
                  <button
                    className='inventory-status__text-link'
                    onClick={()=> handleOpenDrawer()}
                  >
                    {myStoreLocationData.name}
                  </button>
                </span>
              </span>
            </span>
          </div>

          {/* In-store status */}
          <div className={`inventory-status__status ${inStoreStatus} ${isLoading ? 'loading' : ''}`}>
            <div className='inventory-status__status-title'>
              {themeI18n('products.inventory.in_store_availability')}
            </div>

            <span className="inventory-status__content">
              <span className="inventory-status__text inventory-status__text--in-stock">
                <Icons icon='success' size='small' />
                <span>
                  {themeI18n('products.inventory.in_stock_at')}
                  <button
                    className='inventory-status__text-link'
                    onClick={()=> handleOpenDrawer()}
                  >
                    {myStoreLocationData.name}
                  </button>
                </span>
              </span>

              <span className="inventory-status__text inventory-status__text--sold-out">
                <Icons icon='error' size='small' />
                <span>
                  {themeI18n('products.inventory.sold_out_at')}
                  <button
                    className='inventory-status__text-link'
                    onClick={()=> handleOpenDrawer()}
                  >
                    {myStoreLocationData.name}
                  </button>
                </span>
              </span>
            </span>
          </div>
        </>
      )}

      <button
        className='inventory-status__floating-button'
        onClick={()=> handleOpenDrawer()}
      >
        {themeI18n('products.inventory.change_store')}
      </button>

      <StoresDrawer locationInventories={locationInventories} drawerName="_inventory" myStoreLocationSinceDrawerOpened={myStoreLocationSinceDrawerOpened} myStoreLocation={myStoreLocation} setMyStoreLocation={setMyStoreLocation} />
    </>
  )
}
